type MaskedIconProps = {
  src: string;
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
};

export function MaskedIcon({
  src,
  size = 24,
  color = "currentColor",
  className,
  style,
}: MaskedIconProps) {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;

  return (
    <span
      className={className}
      aria-hidden="true"
      style={{
        display: "inline-block",
        width: resolvedSize,
        height: resolvedSize,
        backgroundColor: color,
        WebkitMaskImage: `url("${src}")`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
        maskImage: `url("${src}")`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        ...style,
      }}
    />
  );
}
